import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import CheckContent from '../../../CheckContent';
import FormGroup from '../../../FormGroup';
import { I18nContext } from 'utils/I18n/context';

const PayoutItemContent = ({
    isEmpty: propIsEmpty,
    data: propData,
    loading: propLoading,
    getPayout,
    params
}) => {
    const { t } = useContext(I18nContext);
    const [isEmpty, setIsEmpty] = useState(propIsEmpty);
    const [data, setData] = useState(propData);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPayout(params.id);
    }, [getPayout, params.id]);

    useEffect(() => {
        setIsEmpty(propIsEmpty);
        setData(propData);
        setLoading(propLoading);
    }, [propIsEmpty, propData, propLoading]);

    const staticNames = t?.payoutItemPage || {};
    const staticNameLabels = t?.dataTable?.headers || {};
    const commonKeys = Object.keys(data.common || {});
    const paymentMethodKeys = Object.keys(data.paymentMethod || {});

    return (
        <CheckContent
            loading={loading}
            isEmpty={isEmpty}
        >
                    <div className="payout__item-wrapper">
                        <div>
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>{staticNames.generalInfo}</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="form-horizontal form-horizontal_flex">
                                        {commonKeys.map((key) => (
                                            <FormGroup
                                                key={key}
                                                label={`${staticNameLabels[key]}:`}
                                            >{this.state.data.common[key]}</FormGroup>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>{staticNames.paymentMethod}</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="form-horizontal form-horizontal_flex">
                                        {paymentMethodKeys.map((key) => (
                                            <FormGroup
                                                key={key}
                                                label={`${staticNameLabels[key]}:`}
                                            >{this.state.data.paymentMethod[key]}</FormGroup>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CheckContent>
        );
};

PayoutItemContent.propTypes = {
    isEmpty: PropTypes.bool,
    data: PropTypes.shape({
        common: PropTypes.object,
        paymentMethod: PropTypes.object,
        currency: PropTypes.object
    }),
    loading: PropTypes.bool,
    getPayout: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired
};

PayoutItemContent.defaultProps = {
    isEmpty: false,
    data: {
        common: {},
        paymentMethod: {},
        currency: {}
    },
    loading: false
};

export default PayoutItemContent;
